import { createSlice } from '@reduxjs/toolkit';

import { IAttractionsState } from './interfaces';
import { loadAttractionItem, loadAttractionsList } from './actions';

export const attractionsSlice = createSlice({
  name: 'attractions',
  initialState: {
    list: [],
    item: {},
    limit: 20,
    total: 0,
    offset: 0,
    isLoading: true,
  } as IAttractionsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadAttractionsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
        state.isLoading = false;
      }
    );
    builder.addCase(loadAttractionsList.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(loadAttractionsList.rejected, state => {
      state.isLoading = false;
    });
    builder.addCase(loadAttractionItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
